import React from 'react'
// import { FormContextProvider } from '../../../../../context/formContext'
import ElegibilidadFormEdit from './ElegibilidadEdit'
// import Toast from '../../../../../components/Toast/Toast'
import { useLocation } from 'react-router-dom'
import { ElegibilidadProvider } from '../../../../../context/ElegibilidadContext'
import { EligibilityContextProvider } from '../../../../../context/EligibilityContext'

const FormElegibilidadEdit = () => {
  const location = useLocation()
  return (
    <ElegibilidadProvider>
      <EligibilityContextProvider>
        <ElegibilidadFormEdit idForm={location.state} />
      </EligibilityContextProvider>
    </ElegibilidadProvider>
  )
}

export default FormElegibilidadEdit
